import { Component, OnInit, ViewChild } from '@angular/core';
import { AlertService } from '../../services/alert.service';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { AccessControlService } from 'src/app/services/access-control.service';
import { ToastrService } from 'ngx-toastr';
// declare var $: any;
@Component({
  selector: 'app-add-system-module',
  templateUrl: './add-system-module.component.html',
  styleUrls: ['./add-system-module.component.css']
})
export class AddSystemModuleComponent implements OnInit {
  @ViewChild('addmoduleForm') public addmoduleForm: NgForm
  model: any = {};
  id: any;
  opt: any;
  buttonTitle: String = '';
  title: String = '';
  applicationLists: any = [];
  application: any = [];
  app_id: any;
  application_name:any;
  is_selected: boolean = false;//used to block display drop down for application
  isLoading:boolean;
  isSavingData:boolean=false
  constructor(private authService: AuthService,
    private alertService: AlertService,
    private accesscontrolService: AccessControlService,
    private router: Router,
    private activatedRoute: ActivatedRoute,private toastService:ToastrService) {
    this.id = this.activatedRoute.snapshot.params['id'];
    this.opt = this.activatedRoute.snapshot.queryParamMap.get('opt')
    if (this.opt == 'add') {
      this.app_id = this.activatedRoute.snapshot.queryParamMap.get('app_id');
    }
    else {
      this.app_id = this.activatedRoute.snapshot.params['app_id'];
    }
  }

  ngOnInit() {
  this.application_name=this.activatedRoute.snapshot.queryParamMap.get('appname');

    if (this.opt == 'add') {
      this.buttonTitle = 'Save'
      this.title = 'Add Module'
    }
    else {
      this.buttonTitle = 'Update'
      this.title = 'Edit Role'
      this.getsystemModulebyId();
    }
    this.listallapplications();
    if (this.app_id + "" != 'not-set') {
      this.is_selected = true;
      this.getapplicationbyId();
    }
  }
  submit() {
    if (!this.addmoduleForm.valid) {
      return
    }
    if (this.opt == 'add') {
      this.addsystemModule();
    }
    else {
      this.updatesystemModule();
    }
  }
  getapplicationbyId() {
    this.accesscontrolService.getapplicationbyId(this.app_id).subscribe((res) => {
      this.application = res;
      this.model.application_id = this.app_id
      this.model.application_code = this.application.application_code;
      this.model.application_name = this.application.application_name;
    }, error => {
      console.log(error)
    },
      () => {

      })
  }

  selected_application(application_id: any) {
    this.app_id = application_id;
    this.getapplicationbyId();
  }
  listallapplications() {
    this.accesscontrolService.listallapplications().subscribe((res) => {
      this.applicationLists = res;
    }, error => {

    }, () => {
    })
  }
  //add System Module
  addsystemModule() {
    this.isSavingData=true
    this.model.value = false
    // this.model.created_by = localStorage.getItem('username')
    this.accesscontrolService.addsystemModule(this.model).subscribe((res) => {
    }, error => {
      this.isSavingData=false
      var errorMessage = error && error.error && error.error.message ? error.error.message : 'Sorry, Something went wrong!';
      this.toastService.error(errorMessage)
    }, () => {
      this.isSavingData=false
      this.toastService.success("System Module Added Successfully");
      if (this.app_id + "" != 'not-set') {
        this.router.navigate(['/edit-module-listing/' + this.app_id],{queryParamsHandling:"preserve"});
      }
      else {
        this.router.navigate(['/module-listing'],{queryParamsHandling:"preserve"});
      }

    })
  }
  getsystemModulebyId() {
    this.isLoading=true
    this.accesscontrolService.getsystemModulebyId(this.id).subscribe((res) => {
      this.model = res;
      this.isLoading=false
    }, error => {
      this.isLoading=false
      console.log(error)
    },
      () => {
      })
  }
  updatesystemModule() {
    this.isSavingData=true
    this.accesscontrolService.updatesystemModule(this.model,this.app_id).subscribe((res) => {
      this.isSavingData=false
      this.model = res
    }, error => {
      this.isSavingData=false
      var errorMessage = error && error.error && error.error.message ? error.error.message : 'Sorry, Something went wrong!';
      this.toastService.error(errorMessage)
    }, () => {
      this.isSavingData=false
      this.toastService.success("Module Updated Successfully");
      if (this.app_id + "" != 'not-set') {
        this.router.navigate(['/edit-module-listing/' + this.app_id],{queryParamsHandling:"preserve"});
      }
      else {
        this.router.navigate(['/module-listing'],{queryParamsHandling:"preserve"});
      }
    })
  }
  cancel() {
    if (this.app_id + "" != 'not-set') {
      this.router.navigate(['/edit-module-listing/' + this.app_id],{queryParamsHandling:"merge"});
    }
    else {
      this.router.navigate(['/module-listing'],{queryParamsHandling:"merge"});
    }
  }
}
